/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'home': {
    width: 800,
    height: 800,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M141.364 285.24l303.095-184.376a122.727 122.727 0 01127.76.081l301.5 184.214a122.727 122.727 0 0158.786 104.727v449.387A122.727 122.727 0 01809.777 962H205.182A122.727 122.727 0 0182.455 839.273V390.09a122.727 122.727 0 0158.909-104.85zm34.036 55.924a57.273 57.273 0 00-27.49 48.927v449.182a57.273 57.273 0 0057.272 57.272h604.554a57.273 57.273 0 0057.273-57.272V389.927a57.273 57.273 0 00-27.409-48.886L538.1 156.868a57.273 57.273 0 00-59.645-.082L175.4 341.164z"/><path pid="1" d="M348.364 769.727h327.272a32.727 32.727 0 100-65.454H348.364a32.727 32.727 0 100 65.454z"/>'
  }
})
